import type { FareRulesType, TripSegmentType } from '../../order-details/models';

export const shouldShowFareRules = ({
  p,
  t,
  fareRules = [],
  texts = {},
}: {
  p: (value: string) => any;
  t: (...args: any) => string;
  fareRules: FareRulesType;
  texts?: Record<string, string>;
}): boolean => {
  if (!p('Order.ShowFareRules.Enabled')) {
    return false;
  }

  if (fareRules && fareRules.length > 0) {
    return true;
  }

  if (!texts?.systemLCCTitleAndContent) {
    return false;
  }

  if (!p('Order.ShowFareRulesForLcc.Enabled')) {
    return false;
  }

  return (
    texts?.fareRulesDescription === t('Air.Result.FareRules.LCCDescription.FareRulesDoesNotExist')
  );
};

export const isFutureTravelDate = (tripSegments: TripSegmentType[] = []): boolean =>
  tripSegments.length > 0 &&
  new Date(tripSegments[tripSegments.length - 1].departuredAt).getTime() > new Date().getTime();
